module.exports = __webpack_public_path__ + "r-v3/img/voiceRequest_white.8073809d.svg";